import React from "react";
import {
  LandingSection,
  SectionHeader,
} from "./landing/landing-ui";

const signals = [
  {
    title: "Evaluation before scale",
    description:
      "We define success criteria and test against real samples before a pilot is treated as production-ready.",
  },
  {
    title: "Integration without rip-and-replace",
    description:
      "Systems connect to the tools you already run. We do not force a greenfield stack to ship value.",
  },
  {
    title: "Operator handoff",
    description:
      "Runbooks, ownership, and monitoring so the system does not depend on a single engineer after launch.",
  },
  {
    title: "Scoped commercial clarity",
    description:
      "You know what is in, what is out, and what the next decision point is. No open-ended research retainers by default.",
  },
];

function DeliverySignals() {
  return (
    <LandingSection>
      <SectionHeader
        title="What production-ready means here"
        lead="We treat reliability, ownership, and measurable outcomes as part of the build, not a follow-up project."
      />
      <div className="mt-12 grid gap-4 sm:grid-cols-2">
        {signals.map((item) => (
          <div
            key={item.title}
            className="rounded-2xl border border-line bg-surface p-6"
          >
            <h3 className="text-lg font-semibold text-ink">{item.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-ink-muted">
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </LandingSection>
  );
}

export default DeliverySignals;
